'use strict';

module.exports.classic = require('./classic');



//////////////////
// WEBPACK FOOTER
// ./~/tartan/src/schema/index.js
// module id = 136
// module chunks = 0